import Button from '@mui/material/Button'
import CircularProgress from '@mui/material/CircularProgress'

import { BaseIconButtonProps } from '../types'

interface LoadingButtonProps extends BaseIconButtonProps {
  loading: boolean
}

/**
 *
 * @description A button with an arrow forward icon on the right.
 *
 */
const LoadingButton = ({ loading, ...props }: LoadingButtonProps) => (
  <Button {...props}>
    {loading ? <CircularProgress size={20} color="inherit" /> : props.children}
  </Button>
)

export default LoadingButton
